import React, { useEffect, useState } from "react";
import axios from "axios";
import AddressModal from "./AddressModal";
import { toast } from "react-toastify";

const MyAddress = () => {
  const user_id = localStorage.getItem("user_id");
  

  const [addressData, setAddressData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedAddress, setSelectedAddress] = useState(null);


  /* =========================
     FETCH ADDRESS
  ========================== */
    useEffect(() => {
    if (user_id) {
      fetchAddresses();
      // fetchCartTotals();
    }
  }, [user_id]);

  const fetchAddresses = async () => {
  try {
    const res = await axios.post(
      "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_contact_details_address",
      { user_id }
    );
    

    if (res.data.status === "true") {
      setAddressData(res.data.data || []);
    }
  } catch (err) {
    console.error(err);
  }
};

const deleteAddress = async (contact_id) => {
    if (!window.confirm("Are you sure you want to delete this notification?")) {
      return;
    }

    try {
      const response = await axios.post(
        "https://cyberathon.com/streekatha/API/index.php/Master_controller/delete_contact_details_address",
        { contact_id }
      );

      if (response.data.status === "true") {
        toast.error("Address deleted successfully!");
        setAddressData((prev) => prev.filter((item) => item.contact_id !== contact_id));
      } else {
        toast.error("Failed to delete Address.");
      }
    } catch {
      toast.error("Something went wrong while deleting Address.");
    }
  };

  return (
    <>
      <div className="card profile-card border-0">
        <div className="card-body">
          <h5 className="card-title">My Addresses</h5>

          {addressData.length > 0 ? (
  addressData.map((addr) => (
    <div className="address-box" key={addr.contact_id}>
      <p><strong>{addr.address_type}</strong></p>

      <p><strong>Name:</strong> {addr.name}</p>
      <p><strong>Phone:</strong> {addr.phone}</p>

      <p>
        <strong>Address:</strong> {addr.address}
        {addr.landmark && `, ${addr.landmark}`}
      </p>

      <p><strong>Location:</strong> {addr.location}</p>

      <p>
        <strong>City / State:</strong> {addr.city}, {addr.state}
      </p>

      <p><strong>Pincode:</strong> {addr.pincode}</p>

      <div className="address-actions mt-2">
        <button
  className="btn btn-outline-primary btn-sm"
  onClick={() => {
    setSelectedAddress(addr);
    setModalMode("edit");
    setShowModal(true);
  }}
>
  Edit
</button>


        <button
                                    onClick={() => deleteAddress(addr.contact_id)}
                                    className="btn btn-outline-danger btn-sm ms-2"
                                  >
                                    Delete
                                  </button>
      </div>
    </div>
  ))
) : (
  <p>No addresses found</p>
)}


          <button
            className="button3 mt-3"
            onClick={() => {
              setModalMode("add");
              setShowModal(true);
            }}
          >
            Add New Address
          </button>
        </div>
      </div>

      <AddressModal
  isOpen={showModal}
  onClose={() => {
    setShowModal(false);
    setSelectedAddress(null); // Reset selected address
  }}
  mode={modalMode}
  editData={selectedAddress}   
  refreshList={fetchAddresses}
/>

    </>
  );
};

export default MyAddress;
